import { Component, OnInit } from '@angular/core';
import { UIService } from './shared/services';
import { VersionCheckService } from '@shared/services/version-check/version-check.service';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/modules/loader/loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, LoaderComponent],
})
export class AppComponent implements OnInit {
  title = 'swift';
  extraIcons = [
    // Use src/shared/static/icons.ts and check for a suitable icon before adding.
  ];

  constructor(
    private uiService: UIService,
    private versionCheckService: VersionCheckService
  ) {
    uiService.registerIcons(this.extraIcons);
  }

  ngOnInit(): void {
    this.versionCheckService.startMonitoring();
  }
}
